import { Component } from "react";
import { connect } from "react-redux";
import SettingItem from "./settingsComponents/collapse-settings";
import InvoicePriceSetting from "./settingsComponents/invoice-price-settings";
import axios from "axios";
import urls from "../urls";
import { showError, showSuccess } from "../utils";
import { setGlobalSettings } from "../redux-state/features/setting/settingsSlice";
import CreateNewFacultyAccountForm from "./settingsComponents/create-new-faculty-account";

class Settings extends Component {
  /**
   *
   */
  constructor() {
    super();
  }
  componentDidMount() {
    console.log("userEmail", this.props.userEmail);
  }
  updateSettings = (obj) => {
    axios
      .post(urls.updateSettings, obj)
      .then((res) => {
        console.log(res.data);
        this.props.setGlobalSettings({ invoice_price: obj.setting_value });
        showSuccess("تم حفظ التغييرات ");
      })
      .catch((err) => {
        showError("لم  يتم الحفظ بنجاح ");
        console.log(err);
      });
  };
  render() {
    const settingsElements = [
      {
        text: "استعمال السعر في الفواتير ",
        Child: ({ updateSettings }) => (
          <InvoicePriceSetting updateSettings={updateSettings} />
        ),
      },
    ];

    return (
      <div>
        <h5 style={{ display: "flex", alignItems: "center" }}>
          الإعدادات
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid black",
              marginRight: "8px",
            }}
          ></span>
        </h5>

        <div className="container ">
          {this.props.userEmail === "soufyanebouguetaia48@gmail.com" && (
            <SettingItem title={"إنشاء حساب كليّة جديد "}>
              <CreateNewFacultyAccountForm />
            </SettingItem>
          )}
          {settingsElements.map((setting, index) => (
            <SettingItem key={index} title={setting.text}>
              <setting.Child updateSettings={this.updateSettings} />
            </SettingItem>
          ))}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { setGlobalSettings };
const mapStateToProps = (state) => ({
  userEmail: state.userState.userEmail,
});
export default connect(mapStateToProps, mapDispatchToProps)(Settings);
